import _ from 'lodash';
import moment from 'moment';

// inputDate can be date integer or string in format of 'YYYY-MM-DD'
export const getMomentDate = (inputDate) => {
  inputDate = inputDate || '';
  if (!inputDate) {
    return null;
  } else {
    if(_.isNumber(inputDate)) {
      return moment(inputDate).toDate();
    } else {
      return moment(inputDate, 'YYYY-MM-DD').toDate();
    }
  }
}

export const getFormattedDate = (inputDate) => {
  let result = '';
  if (inputDate) {
    result = moment(inputDate).format('MM/DD/YYYY');
  }
  return result;
}

export const getUrlParams = (searchText) => {
  let params = {};
  let paramsText = searchText;
  paramsText = (paramsText && paramsText.substring(1)) || '';
  if (paramsText.startsWith('key=')) {
    paramsText = paramsText && paramsText.substring(4);
    const buf = Buffer.from(paramsText, 'base64');
    const result = buf.toString('ascii');
    const paramItems = result.split(':');
    params = {
      program: paramItems[0],
      study: paramItems[1],
      milestone: paramItems[2],
      groupId: paramItems[3],
      user: paramItems[4],
      type: 'output'
    };
  } else if (paramsText.startsWith('token=')) {
    params = {
      token: paramsText.substr(6)
    };
  } else {
    try {
      let jsonText = '{"' +
        decodeURI(paramsText).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') +
      '"}';
      params = JSON.parse(jsonText);
    } catch(e) {
      console.log('error in parse params');
    }
  }
  return params;
}

export const getEditRecord = (input, editRecord) => {
  let result = {
    request_id: editRecord.request_id,
    program: editRecord.program,
    study: editRecord.study,
    milestone: editRecord.milestone,
    related_task_name: editRecord.related_task_name,
    urgency_level: editRecord.urgency_level,
    request_date: editRecord.request_date,
    due_date: editRecord.due_date,
    requester_name: editRecord.requester_name,
    requester_org: editRecord.requester_org,
    request_title: editRecord.request_title,
    description: editRecord.description,
    request_status: editRecord.request_status,
    approve_by: editRecord.approve_by,
    request_approve_date: editRecord.request_approve_date,
    response_lead: editRecord.response_lead,
    statusDate: editRecord.statusDate,
    request_cancel_date: editRecord.request_cancel_date,
    request_cancel_by: editRecord.request_cancel_by,
    programmer: editRecord.programmer,
    programmer_request_date: editRecord.programmer_request_date,
    programmer_complete_date: editRecord.programmer_complete_date,
    delivery_date: editRecord.delivery_date,
    number_datasets: editRecord.number_datasets,
    number_figures: editRecord.number_figures,
    number_tables: editRecord.number_tables,
    number_listings: editRecord.number_listings,
    attachments: editRecord.attachments || [],
    showReqResponsePanel: editRecord.showReqResponsePanel,
  };
  for (var property in input) {
    result[property] = input[property];
  }
  return result;
};

export const newGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = Math.random() * 16 | 0;
		const v = (c === 'x') ? r : (r & 0x3 | 0x8);
    return v.toString(16);
	});
}

export const getTimeDiff = (startTime, endTime, unit = 'days') => {
  let result = '';
  let start = moment(startTime);
  let end = moment(endTime);
  if (start && end) {
    result = end.diff(start, unit, true);
  }
  return result || '';
}

export const toDateString = (input, format='MM/DD/YYYY') => {
  let result = '';
  if (input) {
    result = moment(input).format(format);
  }
  return result;
}

export const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer =
    setTimeout(() => func.apply(context, args), delay);
  }
}

